import { formatToday } from '../../../../../../../utility/formats/formattedDate'

//Departamentos de bancos tal como llegan en `department` de cada actividad.
//Kuspit tiene su propio catálogo de cuentas MXN; Toluca es el único departamento sin acceso Kuspit
export const DEPARTMENTS = {
    TOLUCA: 'Bancos-Toluca',
    KUSPIT: 'Bancos-Kuspit'
}

//Pestañas principales de la pantalla: todas las transferencias (admin) y las asignadas al usuario
export const TRANSFERS_TABS = {
    ALL: 'allActivities',
    MINE: 'myActivities'
}

//Subpestañas de "Mis transferencias" en MXN, sólo visibles con acceso Kuspit
export const DEPARTMENT_TABS = {
    TOLUCA: 'Toluca',
    KUSPIT: 'Kuspit'
}

//Ruta a la que apuntan las pestañas de cada moneda
export const TRANSFERS_ROUTES = {
    MXN: '/bank/transfers/mxn',
    USD: '/bank/transfers/usd'
}

//Tipo de lista de MyActivities: se muestra en el título y arma el id del filtro de fechas
export const ACTIVITY_TYPES = {
    PENDING: 'pendientes',
    APPLIED: 'completadas'
}

//Columnas de Activities que Mis transferencias oculta al montar: el usuario ya sabe que son suyas
export const MY_ACTIVITIES_HIDDEN_COLUMNS = {
    original_client_name: false,
    emisor: false,
    assigned_to: false,
    registered_by: false,
    requested_by: false,
    status: false,
    department: false
}

//Textos del Swal de cada envío de Mis transferencias
export const MY_ACTIVITY_MESSAGES = {
    apply: {
        success: 'Actividad aplicada exitosamente',
        error: 'Error al aplicar la actividad'
    },
    voucher: {
        success: 'Voucher actualizado exitosamente',
        error: 'Error al actualizar el voucher'
    },
    account: {
        success: 'Cuenta cambiada exitosamente',
        error: 'Error al cambiar la cuenta'
    }
}

//Columnas de Activities que la tabla de pendientes oculta al montar
export const PENDING_ACTIVITIES_HIDDEN_COLUMNS = {
    original_client_name: false,
    emisor: false,
    deposit_account: false,
    assigned_to: false,
    registered_by: false,
    requested_by: false,
    status: false
}

//Columnas de Activities que "Todas las transferencias" oculta al montar
export const ALL_ACTIVITIES_HIDDEN_COLUMNS = {
    registered_by: false,
    requested_by: false
}

//Columnas de Activities que el modal de estadísticas de un usuario oculta al montar
export const USER_STATS_HIDDEN_COLUMNS = {
    registered_by: false,
    department: false,
    requested_by: false
}

//Departamentos del select de Asignar. La primera opción (Toluca) es el valor inicial del formulario
export const ASSIGN_DEPARTMENT_OPTIONS = [
    { value: DEPARTMENTS.TOLUCA, label: 'Toluca' },
    { value: DEPARTMENTS.KUSPIT, label: 'Kuspit' }
]

//Departamentos del select de Transferir: mismos valores que Asignar, con la etiqueta completa
export const TRANSFER_DEPARTMENT_OPTIONS = [
    { label: 'Bancos Toluca', value: DEPARTMENTS.TOLUCA },
    { label: 'Bancos Kuspit', value: DEPARTMENTS.KUSPIT }
]

//Roles que pueden recibir transferencias asignadas: 6 es Bancos-Toluca y 9 Bancos-Kuspit. Además necesitan
//la ability assignableActivities
export const ASSIGNABLE_ROLE_IDS = [6, 9]

//Estatus de una actividad asignada: tomada por el usuario o ya aplicada
export const ACTIVITY_STATUS = {
    TAKEN: 'taken',
    APPLIED: 'applied'
}

//Títulos de las tres tablas de estadísticas. También deciden qué datos muestra cada tabla y el modal del usuario
export const STATS_TITLES = {
    TAKEN: 'Asignadas',
    APPLIED: 'Aplicadas',
    TOTAL: 'Total'
}

//Nivel de actividad de un usuario: 0 es sin actividad, hasta LOW baja, hasta MEDIUM media y arriba alta
export const ACTIVITY_LEVEL_LIMITS = {
    LOW: 5,
    MEDIUM: 10
}

//Respuesta del admin a una solicitud de borrado de transacción
export const PERMISSION_TO_DELETE = {
    APPROVED: 'approved',
    DENIED: 'denied'
}

//Estatus de la única cuenta bancaria que se puede elegir al aplicar o cambiar cuenta; las demás salen deshabilitadas
export const ACTIVE_ACCOUNT_STATUS = 'Activa'

//Aviso al cancelar una confirmación de Asignar, Transferir o Desasignar. confirmSwal sólo lo muestra con
//`enabled: true`. Es informativo: cancelar no es un error
export const CANCEL_ALERT = { enabled: true, icon: 'info', title: 'Acción Cancelada ✋🏻', text: 'No se hizo ningún cambio.' }

//Fábricas de los formularios de Mis transferencias: se llaman al montar y en cada reset al cambiar de actividad,
//así "hoy" se calcula en el momento y no se queda en el día en que se cargó el módulo
export const createEmptyApplyActivityForm = (id) => ({
    id,
    company: null,
    account: null,
    scheduled_for: formatToday(),
    voucher_file: null
})

export const createEmptyReplaceVoucherForm = (id) => ({
    id,
    type: 'voucher',
    voucher_file: null
})

export const createEmptyChangeAccountForm = (id) => ({
    id,
    type: 'change',
    company: null,
    account: null
})
